/* template */
<template minapp="mpx" xlang="wxml"><div class="drawer-frame-container"><controllable-drawer-bottom :show="(open)" :title="(cusTitle)" :useSimpleHeader="(!leftTitle)" :customStyle="(containerStyle)" :headerStyle="(headerStyle)" @close="closeDrawer"><mpx-view slot="left" @tap="hidePackDetail" class="left-title" v-if="(showPackDetail)"><img src="https://ut-static.udache.com/webx/sfc/MD-Dc6v0Bf220jgs9XgBK.png" class="back-icon"/><div>明细</div></mpx-view><div slot="left" class="left-title" v-else-if="(leftTitle && !useTab)"><div :style='["display: flex"] | transRpxStyle'>{{ title }}<slot name="titleSlot"/></div></div><div slot="left" class="left-title gray-font" v-else-if="(leftTitle && useTab)"><mpx-view v-for="(item, index) in (title)" :class="({'selected': curTab === item.value})" @tap="changeCurTab(item)" class="tab">{{item.text}}</mpx-view></div><slot></slot></controllable-drawer-bottom></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m5c33f4ce"}'>
  .left-title
    position relative
    font-family PingFang SC
    font-size 19px
    font-weight 500
    line-height 23px
    display flex
    align-items center
    &.gray-font
      color #666
    .tab
      position relative
      &.selected 
        color #222
        &::after
          position absolute
          content ''
          bottom 0
          left 50%
          transform translateX(-50%)
          width calc(100% - 5px)
          height 4px
          background #FF6400
      &:not(:last-child)
        margin-right 28px
    .back-icon
      height 20px
      width 20px
      margin-right 4px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5c33f4ce"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex5c33f4ce%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex5c33f4ce%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5c33f4ce"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index5c33f4ce/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'controllable-drawer-bottom':getComponent(require("../../controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
